import { useState } from "react";
import { contactInfo } from "../data/content";

export type ContactFields = {
  nombre: string;
  email: string;
  whatsapp: string;
  perfil: string;
  mensaje: string;
};

export type ContactErrors = Partial<Record<keyof ContactFields, string>>;
export type SubmitStatus = "idle" | "loading" | "success" | "error";

const initial: ContactFields = { nombre: "", email: "", whatsapp: "", perfil: "", mensaje: "" };

function validate(values: ContactFields): ContactErrors {
  const errors: ContactErrors = {};
  if (values.nombre.trim().length < 2) errors.nombre = "Ingresa tu nombre.";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) errors.email = "Ingresa un email válido.";
  if (values.whatsapp.trim() && !/^\+?[\d\s()-]{8,20}$/.test(values.whatsapp.trim()))
    errors.whatsapp = "Ingresa un número válido, con código de país.";
  if (!values.perfil) errors.perfil = "Selecciona un perfil.";
  if (values.mensaje.trim().length < 10) errors.mensaje = "Escribe un mensaje un poco más extenso (mínimo 10 caracteres).";
  return errors;
}

export function useContactForm() {
  const [values, setValues] = useState<ContactFields>(initial);
  const [errors, setErrors] = useState<ContactErrors>({});
  const [status, setStatus] = useState<SubmitStatus>("idle");

  const setField = (field: keyof ContactFields, value: string) => {
    setValues((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const found = validate(values);
    setErrors(found);
    const firstInvalid = Object.keys(found)[0];
    if (firstInvalid) {
      document.getElementById(`field-${firstInvalid}`)?.focus();
      return;
    }
    setStatus("loading");
    try {
      const res = await fetch(`https://formsubmit.co/ajax/${contactInfo.email}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          _subject: `Nueva consulta desde la web – ${values.nombre}`,
          _template: "table",
          _captcha: "false",
          _replyto: values.email,
          Nombre: values.nombre,
          Email: values.email,
          WhatsApp: values.whatsapp || "No indicado",
          Perfil: values.perfil,
          Mensaje: values.mensaje,
        }),
      });
      if (!res.ok) throw new Error("Request failed");
      setStatus("success");
      setValues(initial);
    } catch {
      setStatus("error");
    }
  };

  const reset = () => setStatus("idle");

  return { values, errors, status, setField, handleSubmit, reset };
}
